/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_HeadingInputs */

const tr_servis_s6_heading = /** @type {(inputs: Servis_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Veri İhracı (Data Export) ve Silme`)
};

const en_servis_s6_heading = /** @type {(inputs: Servis_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Data Export and Deletion`)
};

const de_servis_s6_heading = /** @type {(inputs: Servis_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Datenexport (Data Export) und Löschung`)
};

const ru_servis_s6_heading = /** @type {(inputs: Servis_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Экспорт данных (Data Export) и удаление`)
};

/**
* | output |
* | --- |
* | "6. Data Export and Deletion" |
*
* @param {Servis_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_heading = /** @type {((inputs?: Servis_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_heading(inputs)
	if (locale === "de") return de_servis_s6_heading(inputs)
	if (locale === "ru") return ru_servis_s6_heading(inputs)
	return tr_servis_s6_heading(inputs)
});